// extracted by mini-css-extract-plugin
export var divider = "_yy-0";